<template>
  <div class="list-panel">
    <el-card type="form-card" v-loading="loading">
      <div class="basic-info">
        <div class="avatar-info">
          <div class="avatar-out">
            <div class="avatar-in">
              <div class="img-wrap" v-if="accountAvatar">
                <!--有头像-->
                <img
                  v-if="accountAvatar.indexOf('/qr/code') !== -1"
                  :src="accountAvatar"
                  onerror="javascript:this.src='/img/media/wechat_default.png';"
                  class="avatar is-code">
                <img
                  v-else
                  :src="accountAvatar"
                  onerror="javascript:this.src='/img/media/weibo_default.png';"
                  class="avatar">
              </div>
              <div class="img-wrap" v-else>
                <img
                  src="/img/media/weibo_default.png"
                  class="avatar">
              </div>
            </div>
          </div>
          <a v-if="accountUrl" class="link" target="_blank" :href="accountUrl">{{ accountName }}</a>
          <span v-else>{{ accountName }}</span>
        </div>
        <el-divider class="vline" direction="vertical"></el-divider>
        <span>粉丝数：{{ accountFansNum }}</span>
        <el-divider class="vline" direction="vertical"></el-divider>
        <span class="noline-text">总投放次数：{{ putNumAll }}</span>
        <span class="noline-text">总执行金额：{{ readableNum(executeMoneyAll) }}</span>
        <span class="noline-text">博主其他总成本：{{ readableNum(otherCostAll) }}</span>
        <span class="noline-text">分成总收入：{{ readableNum(shareMoneyAll) }}</span>

        <i :class="['media-type-icon', 'type-' + $route.query.mtype]"></i>
      </div>
      <div class="table-wrap">
        <el-table :data="tableData" v-loading="tableLoading" size="mini">
          <el-table-column label="关联合同" prop="name" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.name }}</p>
              <p>（<span :class="['color_' + contractConfig.getAppointed('status_color', scope.row.status)]">
                {{ contractConfig.getAppointed("status_summary", scope.row.status, '') }}
              </span>）</p>
            </template>
          </el-table-column>
          <el-table-column label="品牌名称" prop="customerName" align="center"></el-table-column>
          <el-table-column label="产品名称" prop="brandName" align="center"></el-table-column>
          <el-table-column label="投放次数" prop="putInNum" align="center"></el-table-column>
          <el-table-column label="总执行金额" prop="contractExecuteMoney" align="center">
            <template slot-scope="scope">
              {{ readableNum(scope.row.contractExecuteMoney) }}
            </template>
          </el-table-column>
          <el-table-column label="博主其他总成本" prop="contractOtherCostAll" align="center">
            <template slot-scope="scope">
              {{ readableNum(scope.row.contractOtherCostAll) }}
            </template>
          </el-table-column>
          <el-table-column label="分成总收入" prop="contractShareMoneyAll" align="center">
            <template slot-scope="scope">
              {{ readableNum(scope.row.contractShareMoneyAll) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.putInNum" type="text" size="small" @click="toRelateDelivery(scope.row.id)">查看投放记录</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-wrap">
          <el-pagination
            background
            @size-change="sizeChange"
            @current-change="currentChange"
            :current-page.sync="page.pageNum"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import util from "@/util/util";
import validate from "@/util/validate";
import { contractConfig } from "@/const/config/contract";
import { getBloggerContract } from "@/api/business/contract";
export default {
  data() {
    return {
      contractConfig: contractConfig,

      //总相关
      accountName: '',
      accountFansNum: '',
      accountUrl: '',
      accountAvatar: '',
      putNumAll: '',
      executeMoneyAll: '',
      otherCostAll: '',
      shareMoneyAll: '',
      tableData: [],
      loading: false,
      tableLoading: false,
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      mediaType: null,
      mediaId: null
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange (val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange (val) {
      this.page.pageNum = val;
      this.getList();
    },
    getList() {
      let queryObj = { mediaType: this.$route.query.mtype, mediaId: this.$route.query.mid };
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      this.tableLoading = true;
      getBloggerContract(queryObj)
        .then(res => {
          //基础信息
          this.accountName = res.name;
          this.accountFansNum = res.fansNum;
          this.accountAvatar = res.avatar;
          this.accountUrl = res.url;
          //统计信息
          this.putNumAll = res.putNumAll;
          this.executeMoneyAll = res.executeMoneyAll;
          this.otherCostAll = res.otherCostAll;
          this.shareMoneyAll = res.shareMoneyAll;
          //合同列表
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch(err => {
          //基础信息
          this.accountName = '';
          this.accountFansNum = '';
          this.accountAvatar = '';
          this.accountUrl = '';
          //统计信息
          this.putNumAll = '';
          this.executeMoneyAll = '';
          this.otherCostAll = '';
          this.shareMoneyAll = '';
          //合同列表
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        })
    },
    toRelateDelivery(id) {
      let router = this.$router.resolve({
        path: '/business/contract/relate-delivery',
        query: {
          mtype: this.$route.query.mtype,
          mid: this.$route.query.mid,
          cid: id
        }
      });
      window.open(router.href, '_blank');
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return '';
      return util.priceFormat(num);
    }
  }
}
</script>

<style lang="scss" scoped>
.basic-info {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.avatar-info {
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  color: #409EFF;
  .avatar-out {
    /*width: 50%;*/
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .avatar-in {
      position: relative;
      width: 42px;
      height: 42px;
      margin-right: 5px;
      float: right;
      .img-wrap {
        position: relative;
        border-radius: 50%;
        width: 42px;
        height: 42px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          &.is-code {
            position: absolute;
            top: -84px;
            left: -84px;
            width: 210px;
            height: 210px;
          }
        }
      }
    }
  }
}
.vline {
  margin: 0 15px;
  background-color: #999;
}
.noline-text {
  margin-right: 10px;
}
.media-type-icon {
  position: absolute;
  right: 0;
  top: 0;
  display: block;
  width: 50px;
  height: 30px;
  background: url('/img/media/media-type.png') no-repeat top center/100% auto;
  background-position: 0 -210px;
  &.type-1 {
    background-position: 0 0;
  }
  &.type-2 {
    background-position: 0 -30px;
  }
  &.type-3 {
    background-position: 0 -60px;
  }
  &.type-4 {
    background-position: 0 -90px;
  }
  &.type-5 {
    background-position: 0 -120px;
  }
  &.type-6 {
    background-position: 0 -150px;
  }
  &.type-7 {
    background-position: 0 -180px;
  }
  zoom: 1.2;
}

.table-wrap {
  margin-top: 20px;
}
</style>